<template>
  <v-container fluid>
    <v-row>
      <!--v-col cols="12" lg="3">
        <v-card class="fill-height d-flex flex-column" outlined>
          <v-card-title>
            {{ title }}
          </v-card-title>

          <v-card-text>
            <v-form ref="form">
              <v-autocomplete label="Tipo de Perfil Gestor"
                v-model="params.tipoOrgaoGestor"
                :items="options.tipoOrgaoGestor"
                item-text="descricao" item-value="codigo"
                clearable dense
              />
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn @click="reset()">Limpar</v-btn>
            <v-btn @click="addLayer()" color="#244EA2" dark>
              Pesquisar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col-->
      <v-col cols="12" lg="12">
        <div :id="mapid" style="height: calc(100vh - 200px); width: 100%;"></div>
      </v-col>
      <v-col cols="12">
        <Conselheiro :codigo="codibge"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Conselheiro from './Conselheiro'
import axios from 'axios'
import * as L from 'leaflet'
import * as esri from 'esri-leaflet'
import { uniqueId } from 'lodash'

import { getBounds } from '@/domain/library'

export default {
  name: 'ConselhoMunicipal',
  components: {
    Conselheiro
  },
  data: () => ({
    mapid: null,
    title: 'Conselho Municipal',
    info: null,
    codibge: null,
    /*params: {
      tipoOrgaoGestor: []
    },
    options: {
      tipoOrgaoGestor: []
    }*/
  }),

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.onResize()
    })
  },
  mounted () {
    this.mapid = uniqueId()
    this.$nextTick(() => {
      this.map = L.map(this.mapid)
      this.map.fitBounds(getBounds())
      esri.basemapLayer('Topographic').addTo(this.map)

      L.Control.geocoder({
        position: "topleft",
        placeholder: "Pesquisar..."
      }).addTo(this.map)

      L.control.defaultExtent({
        title: 'Visão Inicial'
      }).addTo(this.map)

      this.addLayer()
    })
  },
  methods: {
    reset () {
      this.$refs.form.reset()
      this.removeLayer()
    },
    addLayer () {
      this.removeLayer()

      // Custom Info Control
      this.info = L.control()

      this.info.onAdd = function () { /* map */
        this._div = L.DomUtil.create('div', 'leaflet-info')
        this.update()
        return this._div
      }

      this.info.update = function (props) {
        this._div.innerHTML = '<h4>Conselho Municipal</h4>' + (props
          ? '<b>' + props.conselho + '</b>'
          : 'Passe o mouse sobre um município'
        )
      }

      this.info.addTo(this.map)

      var style = () => { /* feature */
        return {
          fillColor: 'darkblue',
          weight: 2,
          opacity: 1,
          color: 'white',
          dashArray: '3',
          fillOpacity: 0.7
        }
      }

      var highlightFeature = (e) => {
        var layer = e.target
        layer.setStyle({
          weight: 5,
          color: '#666',
          dashArray: '',
          fillOpacity: 0.7
        })
        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
          layer.bringToFront()
        }
        this.info.update(layer.feature.properties)
      }

      var resetHighlight = (e) => {
        this.geojson.resetStyle(e.target)
        this.info.update()
      }

      var click = (prop) => {
        this.codibge = prop.target.feature.properties.codibge
      }

      function onEachFeature (feature, layer) {
        var template = L.Util.template('<h2><strong>{conselho}</strong></h2>' +
        '<p><strong>Município: </strong>{nome}<br/>' +
        '<p><strong>Instituido por: </strong>{instituidopor}<br/>' +
        '<p><strong>Decreto/Lei: </strong>{decretolei}<br/>' +
        '<p><strong>Email: </strong>{email}<br/>' +
        '<p><strong>Telefone: </strong>{fone}<br/>' +
        '</p>', feature.properties)

        layer.bindPopup(template)

        layer.on({
          mouseover: highlightFeature,
          mouseout: resetHighlight,
          click: click
        })
      }

      this.$store.commit('setLoading', true)

      var params = {
        service: 'wfs',
        version: '2.0.0',
        outputFormat: 'application/json',
        exceptions: 'application/json',
        request: 'GetFeature',
        typeNames: 'seec:conselho_pol_p29192',
        srsName: 'EPSG:4674',
      }

      axios.get(process.env.VUE_APP_GEOSERVER, {
        params: params
      })
        .then(response => {
          this.geojson = L.geoJson(response.data, {
            style: style,
            onEachFeature: onEachFeature
          }).addTo(this.map)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.$store.commit('setLoading', false)
        })
    },
    removeLayer () {
      if (this.geojson) {
        this.map.removeLayer(this.geojson)
        this.geojson = null
      }

      if (this.info) {
        this.map.removeControl(this.info)
        this.info = null
      }
    },
    onResize () {
      if (this.map) {
        this.map.invalidateSize()
      }
    }
  }
}
</script>